export const iconFontAwesomeMapsPhone = (
	<i className="fa-solid fa-phone"></i>
);
